import { useState, useReducer, useContext } from "react";
import { GlobalContext } from "../globalContext";
import { endpoints, apiClient } from "../utils/constants";
import { trackEvent } from "../utils/gtmTracker";

export default function PlannedNotifyForm({ variantType = "FTTH_NON_ATTIVO_FTTC_PIANIFICATO" }) {
  const { store, t } = useContext(GlobalContext);
  const [state, updateState] = useReducer(
    (prev, next) => ({ ...prev, ...next }),
    {
      showConfirmation: false,
      privacyAccepted: false,
      confirmationError: false,
      submitError: false
    }
  );
  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [email, setEmail] = useState("");

  function resetForm() {
    setNome("");
    setCognome("");
    setEmail("");
    updateState({ privacyAccepted: false });
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!state.privacyAccepted) {
      updateState({
        showConfirmation: true,
        confirmationError: true,
        submitError: false
      });
      return;
    }
    const payload = {
      nome,
      cognome,
      email,
      comune: store.selectedAddress || "",
      codiceTopCliente: store.selectedCodeTopClient || "",
      type: variantType
    };
    apiClient
      .post(endpoints.subscribeEmailFromNewsletter, payload, false, true)
      .then(() => {
        trackEvent("planned_fttc_notify_submit", {
          indirizzo: payload.comune,
          codiceTopCliente: payload.codiceTopCliente,
        });
        updateState({ confirmationError: false, showConfirmation: true, submitError: false });
        resetForm();
    })
      .catch((error) => {
        let errorMessage = error?.message || "unknown error";
        let statusCode = error?.response?.status;
        let errorString = statusCode ? `${statusCode}: ${errorMessage}` : `Code not available: ${errorMessage}`;
        trackEvent("planned_fttc_notify_submit_error", {
          planned_notify_submit_error: errorString,
          indirizzo: payload.comune,
          codiceTopCliente: payload.codiceTopCliente,
        });
        updateState({ showConfirmation: true, confirmationError: true, submitError: true });
      });
  };

  return (
    <div className="planned-notify-form-wrapper">
      <h2 className="planned-notify-title">{t.titleModalArriving}<br />{t.titleModalArrivingTwoFTTC}</h2>
      <form className="planned-notify-form" onSubmit={handleFormSubmit}>
        <div className="planned-notify-grid">
          <input type="text" placeholder={t.modalArrivingName} value={nome} onChange={e => setNome(e.target.value)} required />
          <input type="text" placeholder={t.modalArrivingSurname} value={cognome} onChange={e => setCognome(e.target.value)} required />
        </div>
        <input type="email" placeholder={t.modalArrivingEmail} value={email} onChange={e => setEmail(e.target.value)} required />
        <div className="planned-notify-checkbox">
          <input
            type="checkbox"
            id="privacy-planned"
            checked={state.privacyAccepted}
            onChange={() => updateState({ privacyAccepted: !state.privacyAccepted })}
          />
          <label htmlFor="privacy-planned">
            {t.modalPrivacyCheckboxText}
            <a href="https://www.fibercop.it/informazioni/privacy/" target="_blank" rel="noreferrer">{t.modalPrivacyCheckboxTextTwo}</a> {t.modalPrivacyCheckboxTextThree}
          </label>
        </div>
        <div className="planned-notify-privacy-text">{t.modalPrivacySubText}</div>
        <div className="planned-notify-actions">
          <button className="planned-notify-submit-button" type="submit">{t.modalSubmit}</button>
        </div>
      </form>
      {state.showConfirmation && (
        <div className="planned-notify-overlay" onClick={() => {
          updateState({ showConfirmation: false, confirmationError: false, submitError: false });
          resetForm();
        }}>
          <div className="planned-notify-confirmation-modal" onClick={e => e.stopPropagation()}>
            <button
              className="planned-notify-close"
              onClick={() => {
                updateState({ showConfirmation: false, confirmationError: false, submitError: false });
                resetForm();
              }}
              aria-label={t.closePopup}
            >
              ✕
            </button>
            <p className="planned-notify-text">
              {state.confirmationError
                ? state.privacyAccepted
                  ? t.newsletterError
                  : t.privacyRequired
                : t.newsletterSuccess}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
